import { render, staticRenderFns } from "./InputDropdown.vue?vue&type=template&id=54cefcf3&scoped=true&"
import script from "./InputDropdown.vue?vue&type=script&lang=js&"
export * from "./InputDropdown.vue?vue&type=script&lang=js&"
import style0 from "./InputDropdown.vue?vue&type=style&index=0&id=54cefcf3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cefcf3",
  null
  
)

export default component.exports